import {h, Fragment} from "preact"
export function CheckboxColor({ value, selected, onChange, className, bgColor }) {
    let style = `background-color: ${bgColor}`
    if(value == "Multi") {
        style = "background-image: linear-gradient(90deg, #000 25%, transparent 25%, transparent 50%, #000 50%, #000 75%, transparent 75%, #fff);background-size: 7px;"
    }
    return (
        <label className={`ns-checkbox ns-d-flex ns-color-black ns-checkbox-color ${className}`}>
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark colors" style={style} />
            {value}
        </label>
    )
}

export function CheckboxSize({ value, selected, onChange, className }) {
    return (
        <label className={`ns-checkbox ns-d-flex ns-color-black ns-checkbox-size ${className}`}>
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark size">{value}</span>
        </label>
    )
}